module.exports = __webpack_public_path__ + "static/img/all-banner2.4dbe6a5.png";


//////////////////
// WEBPACK FOOTER
// ./static/pawnProducts/all-banner2.png
// module id = T/Jh
// module chunks = 1